<div class="card m-b-10">
    <div class="card-body">
      <app-respondents-approval-search-page-header [hideApproveButton]="true">
      </app-respondents-approval-search-page-header>
      <div class="ml-3 mr-3">
          <div class="row">
              <div class="add-search-respondent">
                  <div class="float-left">
                      <input [ngModel]="term" type="text" name="name" placeholder="{{ 'lang.common.search' | translate }}" (ngModelChange)="emitSearchPattern($event)" />
                  </div>
              </div>
              <div class="btn-cancel" (click)="return()">
                  {{ 'lang.user.cancel'  | translate }}
              </div>
          </div>
        <div>
            <div *ngFor="let businessUnit of businessUnits" class="row p-t-10 p-b-10 br-respondent">
                <div class="col-10 pr-0">
                 
                  <div>
                    <div class="font-weight-bold">
                      {{ businessUnit.displayName }}
                    </div>
                  </div>
                </div>

                <div class="col-1 pr-0 text-right">
                  <span (click)="addRespondentByBU(businessUnit)" class="add-btn test m-r-10">
                  </span>
                </div>
              </div>
        </div>
      </div>
    </div>
  </div>